<template>
  <div>
    <h1 class="homeWelcomeTitle">Welcome to Nucleus</h1>
    <p class="homeWelcomeSubtitle"><i class="mdi mdi-shield-check-outline homeWelcomeIcon"></i>A client portal by Health Information Associates for coding support and coding review services</p>
    <el-row style="margin-top: 40px;" :gutter="30">
      <el-col :span="6">
        <router-link v-if="nucleusUser()" :to="`/${currentClientId}/requests`">
          <el-card class="actionCard" shadow="always">
            <i class="mdi mdi-buffer" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>
            Request Services
          </el-card>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link v-if="nucleusUser()" :to="`/${currentClientId}/documents`">
          <el-card class="actionCard" shadow="always"> <i class="mdi mdi-folder-multiple-outline" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i> Document Manager </el-card>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link v-if="codingDashboard()" :to="`/${currentClientId}/dashboard/coding`">
          <el-card class="actionCard" shadow="always">
            <i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>
            Coding Support Dashboard
          </el-card>
        </router-link>
      </el-col>
      <el-col :span="6">
        <router-link v-if="reviewDashboard()" :to="`/${currentClientId}/dashboard/review`">
          <el-card class="actionCard" shadow="always">
            <i class="mdi mdi-clipboard-check-outline" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>
            Coding Review Dashboard
          </el-card>
        </router-link>
      </el-col>
    </el-row>

    <el-card v-loading="loading" element-loading-spinner="nucleus-loader" class="blogFeed" style="margin-top: 40px;" shadow="always">
      <div slot="header" style="width: 100%">
        <el-row>
          <el-col :span="8">
            Coding Advice and Resources
          </el-col>
          <el-col :span="8">
            <el-input placeholder="" v-model="blogSearch" prefix-icon="el-icon-search">
              <el-button slot="append" @click.stop="handleBlogSearch()">Blog Search</el-button>
            </el-input>
          </el-col>
          <el-col :span="8">
            <div style="float: right;">
              <a href="https://www.facebook.com/HIAcode/" target="_blank"><i class="mdi mdi-facebook socialButton"></i></a>
              <a href="https://twitter.com/HIACode" target="_blank"><i class="mdi mdi-twitter socialButton"></i></a>
              <a href="https://www.instagram.com/hiacode/" target="_blank"><i class="mdi mdi-instagram socialButton"></i></a>
              <a href="https://www.linkedin.com/company/health-information-associates-inc-" target="_blank"><i class="mdi mdi-linkedin socialButton"></i></a>
              <a href="https://www.hiacode.com/hialearn-course-catalog/" target="_blank"><i class="mdi mdi-school socialButton"></i></a>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="24">
          <template v-if="!loading">
            <article v-for="post in blogFeed.results" :key="post.id" id="post-10504" style="margin-bottom: 40px;">
              <el-row :gutter="20">
                <el-col :span="7" style="max-width: 330px;">
                  <a :href="post.link" target="_blank"> <img width="302px" :title="post.name" :src="getFeaturedImageSrc(post)" /> </a>
                </el-col>
                <el-col :span="17">
                  <h2 style="margin-top: 0px;"><a :href="post.url" v-html="post.name" target="_blank"></a></h2>
                  <p>
                    <span>{{ format(parseISO(post.publishDate), 'MMM dd, yyyy') }}</span>
                    <!-- <a v-for="(tag, index) in getTags(post)" :key="tag.link" :href="tag.link" v-html="`${tag.name}${index === getTags(post).length - 1 ? '' : ', '}`" target="_blank"></a> -->
                  </p>
                  <div>
                    <p v-html="post.metaDescription"></p>
                    <a class="el-button el-button--primary el-button--mini" :href="post.url" target="_blank">read more</a>
                  </div>
                </el-col>
              </el-row>
            </article>
            <span @click="fetchEntriesByOffset(postOffset + 5)" class="postNavigationButton"><i class="mdi mdi-chevron-double-left"></i>Older Entries</span>

            <span v-if="postOffset > 0" style="float: right;" @click="fetchEntriesByOffset(postOffset - 5)" class="postNavigationButton">Next Entries <i class="mdi mdi-chevron-double-right"></i></span>
          </template>
        </el-col>
      </el-row>
    </el-card>

    <!--     <div style="margin-top: 50px;">
        <div v-for="post in blogFeed" :key="post.id" v-html="post.excerpt.rendered"></div>
      </div> -->
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapState, mapActions } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'
export default {
  data: function() {
    return {
      blogSearch: '',
      format: format,
      parseISO: parseISO,
      loading: true,
      postOffset: 0
    }
  },
  mixins: [HiaAuthorization],
  name: 'Test',
  components: {
    // VueRssFeed
  },
  methods: {
    ...mapActions('home/', ['GET_BLOG_FEED']),
    getFeaturedImageSrc(post) {
      if (post.featuredImage) {
        return post.featuredImage
      }
    },
    getTags(post) {
      if (post._embedded['wp:term']) {
        if (post._embedded['wp:term'][0]) {
          return post._embedded['wp:term'][0]
        }
      }
      return []
    },
    fetchEntriesByOffset(postOffset) {
      this.loading = true
      this.postOffset = postOffset
      this.GET_BLOG_FEED(this.postOffset).then(() => {
        this.loading = false
      })
    },
    handleBlogSearch() {
      if (this.blogSearch) {
        window.open(`https://hiacode.com/hs-search-results?term=${encodeURI(this.blogSearch)}`, '_blank')
      }
    }
  },
  created: function() {
    this.GET_BLOG_FEED(this.postOffset).then(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('home/', ['blogFeed'])
  }
}
</script>

<style scoped>
>>> .blogFeed {
  min-height: 80vh;
}

>>> .blogFeed .el-card__header {
  padding: 20px 20px;
  font-size: 18px;
  font-weight: 400;
}

.actionCard {
  transition: border-color 0.2s ease;
}

.socialButton {
  font-size: 20px;
  margin: 0px 8px 0px 0px;
  background: transparent;
  color: black;
  opacity: 0.8;
}

.socialButton:hover {
  color: #005695;
}

.actionCard:hover {
  border: 1px solid #005695;
}

.postNavigationButton {
  color: #005695;
  cursor: pointer;
}

.homeWelcomeTitle {
  margin: 0;
  font-size: 28px;
  font-weight: 500;
  color: #303133;
}

.homeWelcomeSubtitle {
  margin: 6px 0 0 0;
  color: #606266;
  font-size: 14px;
}

.homeWelcomeIcon {
  font-size: 16px;
  margin-right: 6px;
  color: #005695;
  vertical-align: text-bottom;
}
</style>
